<template>
  <h1>{{ name }}</h1>
  <c-list
    :border="true"
    :list="list"
    :item-attrs="{ iconTrailing: 'chevron-right', hoverNone: true }"
    size="medium"
  />
</template>

<script>
import CList from '@/components/CList'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import setTitle from '@/functions/setTitle'

export default {
  name: 'CSection',
  components: { CList },
  setup () {
    const route = useRoute()
    const store = useStore()

    const postId = computed(() => route.params.code)
    const section = computed(
      () => store.getters.getNavigation.find(item => item.value === postId.value)
    )

    watch(section, () => setTitle(section.value?.text))
    setTitle(section.value?.text)

    return {
      name: computed(() => section.value?.text),
      list: computed(() => {
        const list = section.value?.list

        if (list) {
          list.forEach(item => {
            if (item.icon === null || item.icon === 'none') {
              item.icon = undefined
            }
          })
        }

        return list
      })
    }
  }
}
</script>

<style lang="scss"/>
